export class SaleItem {
    constructor(data) {
        this._data = data;
        this._title = ko.pureComputed(() => {
            return `${data.banner_discount_title} ${data.banner_discount}% ${data.page_title}`
        });
    }

    get id() {
        return this._data['page_id'];
    }

    get title() {
        return this._title();
    }

    get description() {
        return this._data['page_title'];
    }

    get url() {
        return this._data['page_url'];
    }
}


// WEBPACK FOOTER //
// ./modules/packages/common/model/saleitem.js